





















import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

interface Data {
  errors: string[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: [],
    });

    /******************************
     * 戻るボタン押下
     ******************************/

    const goBack = (): void => {
      context.root.$router.go(-1);
    };

    /******************************
     * テンプレートダウンロード
     ******************************/

    const download = async (): Promise<void> => {
      window.location.href = `/api/teacher/curriculum_upload/download`;
    }

    /******************************
     * アップロードAPI
     ******************************/

    const upload = async (file: File): Promise<void> => {

      if(!confirm("アップロードを実行します。よろしいですか？")){
        return;
      }

      const formData = new FormData();
      formData.append('upload[file]', file);

      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/curriculum_upload/upload`, formData).then(response => {
        alert(`アップロードが完了しました。`);
        goBack();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    return {
      ...toRefs(state),
      goBack,
      download,
      upload,
    };
  },
})
